import { FC } from 'react';
import { IconProps } from '../../types';

export const SilverSmall: FC<IconProps> = ({ width = 12, height = 12, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_6003_117398)">
        <path
          d="M0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6Z"
          fill="url(#paint0_linear_6003_117398)"
        />
        <path
          d="M7.34995 1.888V3.016C7.03795 2.824 6.73795 2.644 6.36595 2.644C6.20995 2.644 6.08995 2.68 6.02995 2.704C5.58595 2.86 5.36995 3.304 5.36995 3.748C5.38195 4.156 5.54995 4.468 5.80195 4.768C6.10195 5.14 6.43795 5.476 6.76195 5.812C7.34995 6.436 7.69795 6.868 7.69795 7.756C7.69795 7.948 7.68595 8.644 7.33795 9.208C7.18195 9.448 6.98995 9.64 6.76195 9.784C6.32995 10.06 5.92195 10.072 5.74195 10.072C5.09395 10.072 4.66195 9.844 4.43395 9.736V8.572C4.54195 8.632 5.02195 8.956 5.54995 8.956C5.81395 8.956 6.00595 8.872 6.08995 8.812C6.24595 8.704 6.53395 8.38 6.53395 7.852C6.53395 7.144 6.12595 6.844 5.28595 5.956C4.67395 5.296 4.19395 4.768 4.19395 3.808C4.19395 3.592 4.21795 3.004 4.54195 2.476C4.73395 2.176 5.21395 1.54 6.18595 1.54C6.77395 1.54 7.15795 1.78 7.34995 1.888Z"
          fill="#FBF4E7"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_6003_117398"
          x1="5.6"
          y1="14.4"
          x2="5.6"
          y2="-2.8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#868686" />
          <stop offset="0.239" stopColor="#646464" />
          <stop offset="0.464" stopColor="#C6C6C6" />
          <stop offset="1" stopColor="#7E7E7E" />
        </linearGradient>
        <clipPath id="clip0_6003_117398">
          <path
            d="M0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
